import React, { useState } from 'react';
import { Tabs, Tab, Paper } from '@material-ui/core';
import { TabPanel } from '../../../shared';
import { ViewServiceDelayBanners } from './ViewServiceDelayBanners';
import { CreateServiceDelayBanners } from './CreateServiceDelayBanners';

const ServiceDelayBanners = () => {
    let [selectedTab, setSelectedTab] = useState('0');
    let handleChange = (event, value) => {
        setSelectedTab(value);
    };

    return (
        <Paper>
            <Tabs onChange={handleChange} value={selectedTab} indicatorColor="primary" textColor="primary" centered>
                <Tab id="ViewDelayBanners_Tab" label="View Service Delay Banners" value="0" />
                <Tab id="CreateDelayBanners_Tab" label="Create Service Delay Banners" value="1" />
            </Tabs>
            <TabPanel selectedTab={selectedTab} index={'0'}>
                <ViewServiceDelayBanners />
            </TabPanel>
            <TabPanel selectedTab={selectedTab} index={'1'}>
                <CreateServiceDelayBanners />
            </TabPanel>
        </Paper>
    );
};

export { ServiceDelayBanners };
